define('areas/home/commands/aaaswitchercommand',["require", "exports"], function (require, exports) {
    "use strict";
    var AAASwitchCommand = (function () {
        function AAASwitchCommand(router, usermanager, applications) {
            this._router = router;
            this._userManager = usermanager;
            this._applications = applications;
        }
        AAASwitchCommand.prototype.execute = function (unit) {
            this._userManager.switchUserAccount();
        };
        return AAASwitchCommand;
    }());
    return AAASwitchCommand;
});

